import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import "../../Style/Theme/index.css";
const LoadingDots = ({ screen = "", displayText = "" }) => {
  const container = useRef(null);

  // useEffect(() => {
  //   lottie.loadAnimation({
  //     container: container.current,
  //     renderer: "svg",
  //     loop: true,
  //     autoplay: true,
  //     animationData: require("../../utils/lottie/loader.json"),
  //   });
  // }, []);
  return (
    <div>
      <div
        // className="lottieContainer loadingDots animationFilter"
        // ref={container}
        style={{
          width: "100%",
          height: "200px",
          position: "relative",
          zIndex: 2,
        }}
      >
        <img
          src="assets/tyger_logo_animation_loader.gif"
          style={{
            backgroundColor: "#072b8240",
            // backgroundColor: "#4c69b1",
            width: "200px",
            height: "150px",
            marginLeft: "25%",
            borderRadius: "10px",
            // display: "flex",
            // verticalAlign: "50%",
            marginTop: "15%",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "10%",
            width: "100%",
            textAlign: "center",
            color: "white",
            fontWeight: "bold",
            fontSize: "1.3rem",
            textShadow: "0 0 0.5rem black",
            // display: screen === "bankStatement" ? "block" : "none",
          }}
        >
          {displayText}
        </div>
      </div>
    </div>
  );
};

export default LoadingDots;
